import * as data from '../../../assets/data/support-services.json';
import { Injectable } from "@angular/core";
@Injectable()
export class SupportServicesService {
  constructor() { }
  getSupportServicesData() {
    return data.default
  }
}
